export function slugify(string: string, allowSlash?: boolean) {
    if (!string) {
        return '' // Retorna uma string vazia se a string original for null, undefined ou vazia.
    }

    const formatedPhrase = string
        .toString() // Cast to string (optional)
        .normalize('NFKD') // Returns the Unicode Normalization Form of a given string.
        .toLowerCase() // Convert the string to lowercase letters
        .replace(/\s+/g, '-') // Replace spaces with -
        .replace(/\-\-+/g, '-') // Replace multiple - with single -
        .replace(/-+$/g, '')

    if (allowSlash) {
        // Remove all non-word chars except slash (/), and ensure only one consecutive slash
        return formatedPhrase
            .replace(/\/+/g, '/')
            .replace(/[^a-z0-9\/-]+/g, '')
    }

    // Remove all non-word chars
    return formatedPhrase.replace(/[^\w\-]+/g, '')
}